import $ from "jquery";
import {MARKET} from 'Utils/market.constants';
import EventBusCustom from './util/eventBusCustom';
import ClientCustomizer from "./commons/clientCustomizer/ClientCustomizer";
import {initCmsUtil} from './util/initCmsUtil';
import {executeQueuedFunctions} from './util/queue';
import {initCookieDisclaimer} from './util/cookie-disclaimer';

import {initSearchContext} from './commons/search';
import Sobot from './commons/search/sobot';
import {initPopinModal} from './commons/Popin/init-popin-modal';

import {filterListWem} from './commons/filter-list-wem';
import {updateBrsShortcuts} from './commons/navigations/brs-shortcut';
import {bindCloseMessageEvent} from './commons/service-messages';
import {showFirstEligibleMessage} from './commons/service-messages';
import {eventsHandler} from './commons/events-handler';
import {processLhsNotifications} from './commons/loginbox/counters';
import {processLoginBoxMenu} from './commons/loginbox/menu';
import {updateLoginBoxNamesLhs} from './commons/loginbox/name';
import {initLastConnectionMessage} from './commons/last-connection-message';
import {processFirstLevelConnected} from './commons/first-level-connected-menu';
import {updateDescription} from './commons/update-description';
import {setHtmlAccessibility} from './commons/setHtmlAccessibility';

import {initInteract} from './commons/interact';
import {initJauge} from './pri/initJauge';
import {bourseLeftMenuActiveItems} from './pri/bourse-left-menu';
import {initSimulator} from './pri/initSimulator';
import {contextualMenuCleanup} from './pri/contextual-menu-cleanups';
import {initCardSubscription} from './pri/initCardSubscription';

import {initSupervision} from './commons/initSupervision';

import {initPopinLogin} from './asso/initPopinLogin'

import {initNavpropri} from './util/navpropri'

import {checkCookieICDSwitch} from'./commons/check-cookie-yoga'
//import {cookieCAID} from './commons/cookieCAID';

require("expose-loader?contextualMenuCMS!./contextual-menu");

const loadCMS = function () {
	
    ClientCustomizer.initialize();
    initCmsUtil();

    // Init Event But
    window.EventBusCMS = new EventBusCustom();

    // commons components
    filterListWem();

    // PRI/PRO CONTEXT
    if (MARKET.CODE === 1 || MARKET.CODE === 2) {
        initInteract();
    }

    initSearchContext();
    initCookieDisclaimer();
    initLastConnectionMessage();
    initPopinModal();
    updateDescription();
    initSupervision();

    // commons Services Messages
    bindCloseMessageEvent();
    showFirstEligibleMessage();

    // Deprecated ?
    setHtmlAccessibility();

    // Cut into Event Customs - Events PRI
    eventsHandler();

    // util commons
    executeQueuedFunctions();

    // PRI CONTEXT
    if (MARKET.CODE === 1) {
        bourseLeftMenuActiveItems();
        initSimulator();
        initCardSubscription();
    }

    // PRI or PRO CONTEXT
    if(MARKET.CODE === 1 || MARKET.CODE === 2){
        if (($('#sobot-l').length > 0) && ($('.js-sobot').length == 1)) {
            var sobotApp = new Sobot();
            sobotApp.initSobot();
        }
    }

    // ASSO CONTEXT
    if (MARKET.CODE === 4) {
        initPopinLogin();
    }

    // launch script only used in connected part
    // IMPORTANT NOTE: if window.cmsUtil.isProspect is false, it doesn't mean that we are in the connected area of the
    // site!!!! It means that the user is either connected or identified!! If the user is connected or identified and
    // we are in the disconnected area, this variable will still be false!!
    if (!window.cmsUtil.isProspect) {
        processLhsNotifications();
        updateLoginBoxNamesLhs();
        updateBrsShortcuts();

        // Need update for PRO
        processLoginBoxMenu();

        // Deprecated ?
        processFirstLevelConnected();

        // PRI CONTEXT
        if (MARKET.CODE === 1) {
            initJauge();
        }
    }

    // PRO AND PRI CONTEXT
    if (MARKET.CODE === 1 || MARKET.CODE === 2) {
        initNavpropri(MARKET.CODE);
    }

    // PRI CONTEXT
    if (MARKET.CODE === 1) {
        contextualMenuCleanup();
    }


    if (MARKET.CODE === 1 || MARKET.CODE === 2 || MARKET.CODE === 3) {
        if(!window.cmsGlobals.checkCookieYogaConfig.disabled || !window.cmsGlobals.checkCookieCMSTechConfig.disabled) {
            if(!window.cmsGlobals.checkCookieYogaConfig.disabled) {
                checkCookieICDSwitch("YOGA");
            }

            if(!window.cmsGlobals.checkCookieCMSTechConfig.disabled){
                checkCookieICDSwitch("CMS_TECH")
            }
        }
    }
	

	// Cookie CAID
	//cookieCAID();
};

export {loadCMS};


// WEBPACK FOOTER //
// ./src/js/cms/loadCMS.js